// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root___bKxZ","rootSuccess":"CompleteLink_rootSuccess__25ghH","rootFailure":"CompleteLink_rootFailure__3FWfa","isDisabled":"CompleteLink_isDisabled__2yFoX"};